import { useMutation } from '@tanstack/react-query';
import useAxios from '../../../app/hooks/useAxios';
import queryClient from '../../../app/utils/queryClient';

const useUserUpdateSettings = () => {
	const { post } = useAxios();

	const userUpdateSettings = (settings: {
		defaultRounding: string;
		defaultLanguage: string;
		realizationStatus: string;
	}) => {
		return post(`/users/me/settings`, settings);
	};

	return useMutation(userUpdateSettings, {
		onSuccess: () => {
			queryClient.invalidateQueries({ predicate: (query) => query.queryKey[0] === 'userProfile' });
		},
	});
};

export default useUserUpdateSettings;
